import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconImpersonateMaskAlt = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.3228 14.4998C10.0465 14.1912 9.57238 14.1649 9.26374 14.4412C8.95509 14.7174 8.92883 15.1915 9.20507 15.5002C9.89065 16.2662 10.8893 16.75 12 16.75C13.1107 16.75 14.1094 16.2662 14.795 15.5002C15.0712 15.1915 15.045 14.7174 14.7363 14.4412C14.4277 14.1649 13.9535 14.1912 13.6773 14.4998C13.2642 14.9613 12.6663 15.25 12 15.25C11.3337 15.25 10.7358 14.9613 10.3228 14.4998Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.971 10.9697C15.6781 10.6768 15.2032 10.6768 14.9103 10.9697C14.6174 11.2626 14.1426 11.2626 13.8497 10.9697C13.5568 10.6768 13.5568 10.2019 13.8497 9.90901C14.7284 9.03033 16.153 9.03033 17.0317 9.90901C17.3245 10.2019 17.3245 10.6768 17.0317 10.9697C16.7388 11.2626 16.2639 11.2626 15.971 10.9697Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.03033 10.9697C8.32322 10.6768 8.7981 10.6768 9.09099 10.9697C9.38388 11.2626 9.85876 11.2626 10.1517 10.9697C10.4445 10.6768 10.4445 10.2019 10.1517 9.90901C9.27297 9.03033 7.84835 9.03033 6.96967 9.90901C6.67678 10.2019 6.67678 10.6768 6.96967 10.9697C7.26256 11.2626 7.73744 11.2626 8.03033 10.9697Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7 2.25C4.92893 2.25 3.25 3.92893 3.25 6V13.5C3.25 18.3325 7.16751 22.25 12 22.25C16.8325 22.25 20.75 18.3325 20.75 13.5V6C20.75 3.92893 19.0711 2.25 17 2.25H7ZM4.75 6C4.75 4.75736 5.75736 3.75 7 3.75H17C18.2426 3.75 19.25 4.75736 19.25 6V13.5C19.25 17.5041 16.0041 20.75 12 20.75C7.99594 20.75 4.75 17.5041 4.75 13.5V6Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconImpersonateMaskAlt as ReactComponent };
